// @flow
import {getProductType, emptyByDefault} from '@optimaxdev/analytics/mobile';
import type {QuoteItemType} from 'constants/flow/flowTypesCart';

import type {OptionType, EecProductType} from 'libs/EEC/productToEECProductType';
import {PRODUCT_TYPES} from 'constants/product';
import {defaultOptions, getContactsColor} from 'libs/EEC/productToEECProduct';
import {getQuantityVariant} from 'libs/EEC/getVariant';
import {prepareBaseImpressionData} from 'libs/EEC/convertData/prepareData';
import {getGender} from 'libs/EEC/getGender';
import {getDiscountedPrice, getPrice} from 'libs/EEC/getPrice';
import {getLensType} from 'libs/EEC/lensType';
import {convertPriceEEC} from 'libs/convertPrice/convertPrice';

/**
 * Convert added product to EEC product
 * @param {Array<QuoteItemType>} products - Products list
 * @param {OptionType} options - Options
 * @returns {Array<EecProductType>} - EEC products
 */
export const productToEECCart = (
    products: Array<QuoteItemType>,
    options: OptionType = defaultOptions,
): Array<EecProductType> =>
    products.map((product: QuoteItemType): EecProductType => ({
        ...prepareBaseImpressionData(product, options),
        price:
            product.type === PRODUCT_TYPES.CONTACT_LENSES
                ? convertPriceEEC(product.discounted_price || product.price)
                : getDiscountedPrice(product),
        product_id: String(emptyByDefault(product.product_id)),
        brand: emptyByDefault(product.brand),
        variant: getQuantityVariant(product),
        quantity: product.qty || 1,
        dimension21: emptyByDefault(options.sku || product.sku),
        dimension23:
            typeof product.custom_options === 'string'
                ? product.custom_options
                : getLensType(product),
        dimension31: product.description_length || 0,
        dimension34: getGender(product),
        dimension35: emptyByDefault(product.gallery_type),
        dimension36: getPrice(product),
        dimension44: getContactsColor(product),
        dimension45: emptyByDefault(product.manufacturer),
        dimension60: getProductType(product.type, Boolean(product.prescription)),
    }));

/**
 * Prepare detail fields for the Cart page in HTO mode.
 *
 * @param {Array<QuoteItemType>} products - Products list
 * @param {OptionType} options - Options
 * @returns {Array<EecProductType>} - EEC products
 */
export const productToEECCartHto = (
    products: Array<QuoteItemType>,
    options: OptionType = defaultOptions,
): Array<EecProductType> =>
    productToEECCart(products, options).map((productItem, index) => ({
        ...productItem,
        dimension51: products[index].productAsHto ? 'In HTO Cart' : 'In Buy Now Cart',
        dimension64: products[index].is_eligible_for_hto ? 'Eligible' : 'Not eligible',
    }));
